import { ISobCompetitorsGroup } from 'partner360/models/ISobCompetitorsGroup'

import { TABLE_HIERARCHY_FIELD, TABLE_KEY_FIELD } from '../configs'

export const getVisibleItems = (data: ISobCompetitorsGroup[], expandedKeys: string[]) => {
  const alwaysVisibleValues = data.filter((el) => el[TABLE_HIERARCHY_FIELD] === null)
  const visibleItems = expandedKeys.reduce((acc, key) => {
    const found = data.find((el) => el[TABLE_KEY_FIELD] === key)
    if (found) {
      const children = data.filter((el) => el[TABLE_HIERARCHY_FIELD] === key)

      return [...acc, found, ...children]
    }

    return []
  }, [] as ISobCompetitorsGroup[])

  return [...alwaysVisibleValues, ...visibleItems].filter(
    (obj, index, self) =>
      index === self.findIndex((o) => o[TABLE_KEY_FIELD] === obj[TABLE_KEY_FIELD])
  )
}
